import { toast } from 'sonner';

import {
  getPoliceReportStatusConfig,
  type PoliceReportAttestationStatus,
} from '@/components/police/utils/policeUtils';
import { useUpdatePoliceReportAttestationStatusMutation } from '@/services/api/police';

import { PoliceStatusSelector } from './forms/PoliceStatusSelector';
import { PoliceStatusBadge } from './PoliceStatusBadge';

interface AttestationStatusSectionProps {
  reportId: string;
  matterId: string;
  currentStatus: PoliceReportAttestationStatus | null | undefined;
  onUpdate: () => void;
}

export const AttestationStatusSection = ({
  reportId,
  matterId,
  currentStatus,
  onUpdate,
}: AttestationStatusSectionProps) => {
  const [updateStatus, { isLoading }] =
    useUpdatePoliceReportAttestationStatusMutation();

  const statusConfig = getPoliceReportStatusConfig(currentStatus);

  const handleStatusChange = async (
    newStatus: PoliceReportAttestationStatus,
  ) => {
    try {
      await updateStatus({
        matterId,
        id: reportId,
        updatePoliceReportAttestationStatus: {
          attestation_status: newStatus,
        },
      }).unwrap();

      toast.success('Report status updated successfully');
      onUpdate();
    } catch (error) {
      toast.error('Failed to update status');
    }
  };

  return (
    <div className="p-6 border-b border-gray-100 bg-gray-50 space-y-4">
      {/* Status Name */}
      <div>
        <PoliceStatusBadge
          status={currentStatus}
          showFullLabel
          size="lg"
          showTooltip
        />
      </div>

      {/* Status Description */}
      <p className="text-sm text-gray-600 leading-relaxed">
        {statusConfig.description}
      </p>

      {/* Actions */}
      <PoliceStatusSelector
        currentStatus={currentStatus}
        onStatusChange={handleStatusChange}
        disabled={isLoading}
        showQuickActions
        size="sm"
      />
    </div>
  );
};
